<div class="irish-registration-capture-container document-capture-container">
  @if (document.isSubmitted === false) {
    <form
      [formGroup]="irishRegistrationForm"
      >
      <div>
        <input
          type="text"
          id="irish-registration"
          formControlName="registrationNumber"
          (change)="onChange()"
          placeholder="Please enter your Irish Registration Number"
          autocomplete="off"
          />
        </div>
        </form>
      }
      <app-document-capture-footer
        [isSubmitted]="document.isSubmitted"
        [enableSubmitButton]="document.enableSubmitButton"
        (submitClicked)="onSubmit()"
      ></app-document-capture-footer>
  </div>
